import {BASE_API} from '../../utils/constantes'
import { getToken } from '../Common/token'

const URL_BASE = `${BASE_API}/api/lizen_tipo_servicio/`

// Extrae el mensaje de error que devuelve el back (DRF usa `detail` o un dict por campo).
async function mensajeError(response){
    try {
        const data = await response.json()
        if(data.detail) return data.detail
        return Object.entries(data).map(([campo,msgs]) => `${campo}: ${[].concat(msgs).join(', ')}`).join(' | ')
    } catch (error) {
        return `Error ${response.status}`
    }
}

export async function getTipoServicio(id){
    try {
        const url =  `${URL_BASE}${id}/`
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
        if(response.status === 200){
            const result= await response.json()
            return result
        }
        return false
    } catch (error) {
        throw new Error ("Hubo un problema, vuelva a intentar")
    }
}

// query_string admite: page, search, aseguradora=<id> (devuelve globales + los del convenio),
// is_active=true|false y paginate=false (lista plana para dropdowns).
export async function getTiposServicio(query_string = null){
    try {
        const url =  query_string === null ? URL_BASE : `${URL_BASE}?${query_string}`
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
        if(response.status === 200){
            const result= await response.json()
            return result
        }
        return false
    } catch (error) {
        throw new Error ("Hubo un problema, vuelva a intentar")
    }
}

// Baja lógica. El back responde 403 si es global y 400 si algún beneficiario lo usa.
export async function deleteTipoServicioLizen(id){
    const url =  `${URL_BASE}${id}/`
    const params = {
        method:"DELETE",
        headers:{
            "Content-Type":"application/json",
            Authorization:`Bearer ${getToken()}`
        }
    }
    const response = await fetch(url,params)
    if(response.status !== 204){
        throw new Error (await mensajeError(response))
    }
    return {status:"sucess",data:"Se eliminó exitosamente"}
}

export async function addTipoServicioLizen(request){
    try {
        const params = {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                Authorization:`Bearer ${getToken()}`
            },
            body: JSON.stringify(request)
        }
        const response = await fetch(URL_BASE,params)
        if(response.status === 200 || response.status === 201){
            const result= await response.json()
            result["status"]= "sucess"
            return result
        }
        return {status:"error", message: await mensajeError(response)}
    } catch (error) {
        throw error
    }
}

export async function editTipoServicioLizen(id,request){
    try {
        const url =  `${URL_BASE}${id}/`
        const params = {
            method:"PUT",
            headers:{
                "Content-Type":"application/json",
                Authorization:`Bearer ${getToken()}`
            },
            body: JSON.stringify(request)
        }
        const response = await fetch(url,params)
        if(response.status === 200){
            const result= await response.json()
            result["status"]= "sucess"
            return result
        }
        return {status:"error", message: await mensajeError(response)}
    } catch (error) {
        throw error
    }
}
